export const rotaJuridico = [

    {
        path: '/juridico/civil',
        name: 'Processo Civil',
        component: () => import("@/views/Juridico/ListarProcessos.vue"),
        meta: {
            obraObrigatoria: true,
            breadcrumb: 'Dashboard',
            title: "Processo Civil",
            icon: 'mdi-scale-balance',
            subject: ['ProcessoJuridico'],
            showMenu: true,
            grupo: "Jurídico",
            grupoTitle: "Jurídico",

        },
    },
    {
        path: '/juridico/trabalhista',
        name: 'Processo Trabalhista',
        component: () => import("@/views/Juridico/ListarProcessos.vue"),
        meta: {
            obraObrigatoria: true,
            breadcrumb: 'Dashboard',
            title: "Processo Trabalhista",
            icon: 'mdi-briefcase-outline',
            subject: ['ProcessoJuridico'],
            showMenu: true,
            grupo: "Jurídico",
            grupoTitle: "Jurídico",

        },
    },
    {
        path: '/juridico/dashboard',
        name: 'Dashboard Juridico',
        component: () => import("@/views/Juridico/Dashboard.vue"),
        meta: {
            obraObrigatoria: true,
            breadcrumb: 'Dashboard',
            title: "Dashboard Jurídico",
            icon: 'mdi-briefcase-outline',
            subject: ['ProcessoJuridico'],
            showMenu: true,
            grupo: "Jurídico",
            grupoTitle: "Jurídico",

        },
    },

    {

        path: '/juridico/enviarDocumentos/:tipoDocumento',
        name: 'trabalhista',
        component: () => import("@/components/Juridico/listarDocumentosJuridico.vue"),
        meta: {
            obraObrigatoria: true,
            breadcrumb: 'Dashboard',
            title: "Jurídico documentos",
            icon: 'mdi-file-document-edit',
            showMenu: false,
            grupo: "Jurídico",
            grupoTitle: "Jurídico",

        },
    },

    
];